<template>

  <div>
    <nav v-if="breadcrumb" class="py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'groups'}">Broadcast Messages</router-link>
          </div>
          <div class="text-xl text-primary">
            Broadcast Messages
          </div>
        </div>
        <div class="">
        </div>
      </div>
    </nav>
    <div :class="id ? 'bg-white pt-3 border rounded shadow-sm px-4 pb-4':''">
      <div :class="fullscreen ? 'p-5 bg-white border rounded shadow-sm':''">
        <div class="text-start bg-white text-start ">
          <div class="font-semibold uppercase mb-4 text-gray-600">{{ title }}</div>
          <div class="">
            <label class="block text-sm ">Subject<span class="text-red-700">*</span></label>
            <input aria-label="Group name" type="text" required v-model="subject"
                   class="input"
                   placeholder="Message Subject"/>
          </div>
          <div class="mt-3">
            <label class="block text-sm leading-5 ">Description</label>
            <textarea name="more_info" type="email" v-model="description"
                      class="input" placeholder="Message description"></textarea>
          </div>

          <div class="mt-6 text-right">
            <button type="submit" v-on:click="saveRecord"
                    class="py-2 px-4 uppercase bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";


export default {
  name: "NewBroadcastMessageComponent",
  components: {},
  data() {
    return {
      subject: this.eSubject,
      description: this.eDescription,
      errors: [],
    }
  },
  props: {
    breadcrumb: {type: Boolean, default: true},
    fullscreen: {type: Boolean, default: false},
    title: {type: String, default: "Draft Message"},
    id: String
  },
  mounted() {
    GraphQl.sendRequest('{broadcast(id:"' + this.id + '"){title  description}}')
        .then(response => {
          this.subject = response.broadcast.title;
          this.description = response.broadcast.description;
        })
  },
  methods: {
    saveRecord() {
      let query = {
        mutation: "createBroadcast",
        input: {
          title: this.subject,
          description: this.description
        },
        output: "{code message recordId}"
      };
      GraphQl.sendRequest(query)
          .then(response => {
            this.$root.$emit(response.createBroadcast.code === 200 ? 'alert_success' : 'alert_error', [response.createBroadcast.message]);
            if (response.createBroadcast.code === 200)
              this.$root.$emit("hide_modal");
          })
          .finally(() => {
            this.$root.$emit("refresh", 'broadcast');
          })
    }
  }
}
</script>

<style>
iframe {
  min-height: 700px !important;
}
</style>